import { jsx } from "react/jsx-runtime";
import React from "react";
var chevron_left_small_default = (prefix = "") => {
  return [
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m8.4004 12.0007 5.785 5.7857 1.4143-1.4141-4.3711-4.3716 4.3711-4.3717-1.4143-1.4142-5.785 5.7859z"
      }
    )
  ];
};
export {
  chevron_left_small_default as default
};
